import { lazy } from 'react';
import i18next from 'i18next';

const OAuthConsent = lazy(() => import('@pages/oauth-consent'));

// Branded MCP OAuth consent screen. The user is SSO-redirected here from the API with an
// opaque `?request_id=` — never client_id/redirect_uri/PKCE, those stay server-side.
// Protected so an unauthenticated visitor is bounced to /login by ProtectedRoute (the API
// sends logged-out users to /login?returnUrl=... itself). `skipDashboardCommonLayout`
// keeps it a standalone branded screen instead of embedding it in the dashboard
// sidebar/topbar shell, the same way the `/docs` service route opts out.
const OAUTH_ROUTE_CONSENT = {
  path: '/oauth/consent',
  exact: true,
  skipDashboardCommonLayout: true,
  additional: {
    component: OAuthConsent,
    protected: true,
    title: i18next.t('titles:authorizeAccess'),
  },
};

export const OAUTH_ROUTES = {
  consent: OAUTH_ROUTE_CONSENT,
};
